<template>
  <div id="roofing">
    <square-footage v-if="step == 'square-footage'" />
    <shingle-layers v-if="step == 'shingle-layers'" />
    <complexity v-if="step == 'complexity'" />
    <material v-if="step == 'material'" />
    <labor v-if="step == 'labor'" />
    <quote v-if="step == 'quote'" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SquareFootage from './components/SquareFootage'
import ShingleLayers from './components/ShingleLayers'
import Complexity from './components/Complexity'
import PitchAngle from './components/PitchAngle'
import Material from './components/Material'
import Labor from './components/Labor'
import Quote from './components/Quote'

export default {
  name: 'app',
  components: {
    SquareFootage,
    ShingleLayers,
    Complexity,
    PitchAngle,
    Material,
    Labor,
    Quote,
  },
  computed: {
    ...mapState({
      step: state => state.Common.step
    })
  },
}
</script>

<style lang="scss">

</style>
